import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=6e9d1d7c&scoped=true&"
import script from "./Results.vue?vue&type=script&lang=js&"
export * from "./Results.vue?vue&type=script&lang=js&"
import style0 from "./Results.vue?vue&type=style&index=0&id=6e9d1d7c&prod&lang=css&"
import style1 from "./Results.vue?vue&type=style&index=1&id=6e9d1d7c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9d1d7c",
  null
  
)

export default component.exports